export const getters = {
  getUserProfile: (_, getters) => (uid) => {
    const organization = getters.currentOrganization;
    if (!organization) {
      return null;
    }

    const user = organization.roles.find((r) => r.uid === uid);

    return user?._uidObj;
  },
  getTopicCounts: (_, getters) => (utterances, roles) => {
    if (!utterances || !getters.currentOrganization) {
      return [];
    }

    const topics = getters.currentOrganization.topics.map((t) => ({
      id: t.id,
      text: t.name || t,
      keywords: t.keywords || [t],
      count: 0,
      timestamps: [],
    }));

    for (const utterance of utterances) {
      for (const topic of topics) {
        for (const keyword of topic.keywords) {
          const isTopicPresent = utterance.text.toLowerCase().includes(keyword);
          if (!isTopicPresent) {
            continue;
          }

          const keywordParts = keyword.split(' ');
          const wordsLoopLength = utterance.words.length - keywordParts.length;

          for (let wordIndex = 0; wordIndex < wordsLoopLength; wordIndex++) {
            for (const [keyworPartIndex, keywordPart] of keywordParts.entries()) {
              const utteranceWord = utterance.words[wordIndex + keyworPartIndex];
              const regex = new RegExp(`\\b${keywordPart}\\b`, 'gi');
              if (!utteranceWord.text.toLowerCase().match(regex)) {
                break;
              }

              if (keyworPartIndex === keywordParts.length - 1) {
                topic.count += 1;
                topic.timestamps.push({
                  start: utterance.words[wordIndex].start,
                  end: utteranceWord.end,
                });
              }
            }
          }
        }
      }
    }

    const questionsBySalesRep = {
      text: 'questions asked',
      count: 0,
      timestamps: [],
    };

    for (const utterance of utterances) {
      const isSalesRep = roles[`Speaker ${utterance.speaker}`] === 'Sales Rep';
      if (!isSalesRep) continue;

      for (let wordIndex = 0; wordIndex < utterance.words.length; wordIndex++) {
        const utteranceWord = utterance.words[wordIndex];
        if (utteranceWord.text.includes('?')) {
          questionsBySalesRep.count += 1;
          questionsBySalesRep.timestamps.push({
            start: utterance.words[wordIndex].start,
            end: utteranceWord.end,
          });
        }
      }
    }
    topics.push(questionsBySalesRep);
    return topics;
  },
  getRole: (_, getters) => (_uid) => {
    if (!getters.currentOrganization) return;
    const foundRole = getters.currentOrganization.roles.find(({ uid }) => uid === _uid);
    return foundRole?.role;
  },
  notificationsPreferences: (state) => {
    if (!state.userProfile?.preferences) {
      return [];
    }
    return Object.keys(state.userProfile.preferences.notifications).filter(
      (key) => state.userProfile.preferences.notifications[key].enabled
    );
  },
  currentOrganization: (state) => {
    return state.organizations?.find(({ id }) => state.currentOrganizationId === id);
  },
  getOrganization: (state) => (id) => {
    return state.organizations?.find(({ id: organizationId }) => organizationId === id);
  },
};
